<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view/>
    
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// import Header from '@/components/header'
// import Footer from '@/components/footer'
export default {
  name: "App",
  // components: { Header,Footer },
  
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
/* #app{width: 100%;}
.contact{
  color:#fff;
  background-color: #f9a72a;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position:fixed;
  right: 10px;
  bottom:10%
}
@media screen and (max-width: 768px){
  .contact{display: none}
} */
</style>



// WEBPACK FOOTER //
// src/App.vue